import React, { useRef, useEffect } from 'react'
import Chart, { ChartData } from 'chart.js/auto'
import styled from 'styled-components'
import { FeesResponse } from '../../../types/API'

interface FeesChartProps {
  data: FeesResponse
}

const FeesChart: React.FC<FeesChartProps> = ({ data }) => {
  const lineData: Record<string, number> = {}
  let totalizer = 0

  for (const value of Object.values(data)) {
    for (const [date, nestedItem] of Object.entries(value)) {
      for (const key in nestedItem) {
        if (!lineData[date]) {
          lineData[date] = 0
        }
        lineData[date] += nestedItem[key]?.totalFeeUsd || 0
        totalizer += nestedItem[key]?.totalFeeUsd || 0
      }
    }
  }

  const processData = () => {
    let allDateLabels: string[] = []
    Object.values(data).forEach((dates) => {
      const currentDates = Object.keys(dates)
      allDateLabels = Array.from(new Set([...allDateLabels, ...currentDates]))
    })

    allDateLabels.sort()

    return { dateLabels: allDateLabels }
  }

  const { dateLabels } = processData()

  const chartData: ChartData<'line', number[], string> = {
    labels: dateLabels,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Fees',
        yAxisID: 'tasks-y-axis',
        data: Object.values(lineData),
        borderColor: 'rgba(14, 179, 161, 1)',
        backgroundColor: 'rgba(14, 179, 161, 0.4)',
        pointBackgroundColor: 'rgba(14, 179, 161, 1)',
        tension: 0.8,
        pointRadius: 7,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: 'rgba(14, 179, 161, 1)',
        pointHoverBorderColor: 'rgba(14, 179, 161, 1)',
      },
    ],
  }

  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const chartRef = useRef<Chart | null>(null)

  const createChart = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d')
      if (ctx) {
        chartRef.current = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: {
            responsive: true,
            scales: {
              'tasks-y-axis': {
                beginAtZero: true,
              },
            },
          },
        })
      }
    }
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy()
    }
  }

  useEffect(() => {
    createChart()

    return () => {
      destroyChart()
    }
  }, [data])

  return (
    <>
      <h1>Fees {totalizer > 0 && <Tot>Total: {totalizer.toFixed(2)} USD</Tot>}</h1>
      <div>
        <canvas ref={canvasRef} />
      </div>
    </>
  )
}

const Tot = styled.p`
  font-size: 14px;
  display: inline-flex;
  background: rgba(14, 179, 161, 1);
  padding: 5px 10px;
  border-radius: 22px;
  margin-left: 18px;
`

export default FeesChart
